export default __webpack_public_path__ + "images/fef171315512ddd39d1743089db9883f-404_rainy_cloud_light.png";